import { ImgHTMLAttributes } from 'react';

const GRAPHIC_CDN_URL = 'https://cdn.banksalad.com/graphic';

export const GRAPHIC_URL = {
  INVESTMENT_STOCK_ICON: `${GRAPHIC_CDN_URL}/color/icon/investment/stock-large1.svg`,
  INVESTMENT_FUND_ICON: `${GRAPHIC_CDN_URL}/color/icon/investment/fund-large1.svg`,
  INVESTMENT_COIN_ICON: `${GRAPHIC_CDN_URL}/color/icon/investment/coin-large1.svg`,
  INVESTMENT_DEPOSIT_ICON: `${GRAPHIC_CDN_URL}/color/icon/investment/deposit-large1.svg`,
  STOCK_LOGO_PLACEHOLDER: `${GRAPHIC_CDN_URL}/color/logo/placeholder/stock.svg`,
  EMPTY_GRAPH_PIE: `${GRAPHIC_CDN_URL}/color/illustration/empty/graph-pie-large.png`,
} as const;

interface Props extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet'> {
  url: string;
}

// The CDN serves the dark mode variant of every graphic as `<name>-darkmode.<ext>`.
// `inline-flex` keeps the picture sized to its image; a plain inline picture adds a baseline gap.
export const Graphic = ({ url, alt = '', ...imgProps }: Props) => (
  <picture style={{ display: 'inline-flex' }}>
    <source
      media="(prefers-color-scheme: dark)"
      srcSet={url.replace(/(\.svg|\.png)$/, '-darkmode$1')}
    />
    <img src={url} alt={alt} {...imgProps} />
  </picture>
);
